import { Injectable } from '@angular/core';
import { CollarsBucketDto } from '../shell-communication/collars-operations';

/**
 * Read access to the per-Combo settings (CR-20260611-001). The settings live on the BACKEND bucket row
 * (sent flat on CollarsBucketDto; saved via the SetCollarsComboSettings command) — replacing the old
 * per-USER 'collars.combo-default-qty.*' user-setting, so everyone viewing the same book sees the same
 * values. This service only normalizes reads; writes go through the command (component run()).
 *
 * Default Qty = the structure-size normalizer the Make-Transaction totals divide by (the Hedging Grid
 * analog is the portfolio default qty its HedgePad totals divide by). Combos saved before the backend
 * field existed arrive with defaultQty = null and fall back to 1 (raw, un-normalized totals).
 */
@Injectable()
export class CollarsComboSettingsService {

   /** The combo's Default Qty; >= 1 integer. Fallback 1 (raw totals) when never set or invalid. */
   getDefaultQty(combo: CollarsBucketDto | null | undefined): number {
      const raw = combo ? combo.defaultQty : null;
      const n = typeof raw === 'number' ? raw : NaN;
      return (isFinite(n) && n >= 1) ? Math.floor(n) : 1;
   }
}
